import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-687e0d79"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "HomeLanding absolute inset-0 flex flex-col items-center justify-center gap-20 px-container text-white overflow-hidden" };
const _hoisted_2 = { class: "Logos flex flex-col items-center gap-32 lg:gap-40 w-min" };
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", {
    class: "Logo",
    "data-row": "0"
}, [
    /*#__PURE__*/ _createElementVNode("img", {
        class: "w-auto max-w-none h-96 lg:h-128",
        src: "/assets/images/partners/logo-claimsconference-white.png",
        srcset: "/assets/images/partners/logo-claimsconference-white.png 1x, /assets/images/partners/logo-claimsconference-white@2x.png 2x",
        alt: "Claims Conference",
        width: "288",
        height: "128",
        decoding: "async"
    })
], -1));
const _hoisted_4 = { class: "flex flex-col lg:flex-row items-center gap-inherit" };
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", {
    class: "Logo",
    "data-row": "1"
}, [
    /*#__PURE__*/ _createElementVNode("img", {
        class: "w-auto max-w-none h-[2.25rem]",
        src: "/assets/images/partners/logo-usc-shoah-white.png",
        srcset: "/assets/images/partners/logo-usc-shoah-white.png 1x, /assets/images/partners/logo-usc-shoah-white@2x.png 2x",
        alt: "USC Shoah Foundation",
        width: "226",
        height: "36",
        decoding: "async"
    })
], -1));
const _hoisted_6 = ["data-row"];
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("img", {
    class: "w-auto max-w-none h-20",
    src: "/assets/images/partners/logo-makemepulse-white.png",
    srcset: "/assets/images/partners/logo-makemepulse-white.png 1x, /assets/images/partners/logo-makemepulse-white@2x.png 2x",
    alt: "makemepulse",
    width: "150",
    height: "22",
    decoding: "async"
}, null, -1));
const _hoisted_8 = [
    _hoisted_7
];
const _hoisted_9 = ["data-row"];
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("img", {
    class: "w-auto max-w-none h-[2.25rem]",
    src: "/assets/images/partners/logo-unesco-white.png",
    srcset: "/assets/images/partners/logo-unesco-white.png 1x, /assets/images/partners/logo-unesco-white@2x.png 2x",
    alt: "unesco",
    width: "170",
    height: "36",
    decoding: "async"
}, null, -1));
const _hoisted_11 = [
    _hoisted_10
];
const _hoisted_12 = ["data-row"];
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("img", {
    class: "w-auto max-w-none h-20",
    src: "/assets/images/partners/logo-meta-white.png",
    srcset: "/assets/images/partners/logo-meta-white.png 1x, /assets/images/partners/logo-meta-white@2x.png 2x",
    alt: "Meta",
    width: "96",
    height: "20",
    decoding: "async"
}, null, -1));
const _hoisted_14 = [
    _hoisted_13
];
const _hoisted_15 = ["data-row"];
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("img", {
    class: "w-auto max-w-none h-96 lg:h-128",
    src: "/assets/images/partners/logos-partners-02-white.png",
    alt: "Foundation EVZ, Federal Ministry of Finance",
    width: "535",
    height: "159",
    decoding: "async"
}, null, -1));
const _hoisted_17 = [
    _hoisted_16
];
const _hoisted_18 = { class: "Shards absolute inset-0 z-1 pointer-events-none" };
const _hoisted_19 = { class: "Glass absolute flex justify-center items-center size-0" };
const _hoisted_20 = { class: "Glass absolute flex justify-center items-center size-0" };
const _hoisted_21 = { class: "Glass absolute flex justify-center items-center size-0" };
import { ref } from "vue";
import useGSAP from "@/composables/useGSAP";
import useMouseParallax from "@/composables/useMouseParallax";
import Viewport from "@/store/modules/Viewport";
import { setFPS } from "@/utils/frameToTime";
import useLocalTransition from "@/composables/useLocalTransition";
export default /*#__PURE__*/ _defineComponent({
    __name: 'HomeLanding',
    props: {
        show: { type: Boolean },
        delay: { default: 0 }
    },
    setup(__props) {
        const props = __props;
        const gsap = useGSAP();
        const frames = setFPS(60);
        const shards = ref([]);
        const show = useLocalTransition(() => props.show);
        const { stop: stopShardsParallax } = useMouseParallax(shards);
        function onBeforeEnter(el) {
            const $ = gsap.utils.selector(el);
            gsap.set($(".Glass"), { y: 0, rotation: 0 });
            gsap.set($(".Logo"), { y: 80, opacity: 0 });
            shards.value = $(".UIShard");
        }
        function onEnter(el, onComplete) {
            const $ = gsap.utils.selector(el);
            const ease = "ease.out";
            const tl = gsap.timeline({
                delay: frames(10) + props.delay,
                defaults: { ease }
            });
            tl
                .to($(".Logo"), {
                y: 0,
                opacity: 1,
                duration: frames(50),
                stagger: (i, el) => {
                    const { row } = el.dataset;
                    return parseInt(row) * frames(10);
                }
            }, 0);
            // shards
            tl.add((() => {
                const tl = gsap.timeline({
                    defaults: {
                        duration: frames(100),
                        ease
                    }
                });
                const pieces = $(".Glass");
                pieces.forEach((glass, i) => {
                    gsap.set(glass, { rotation: gsap.utils.wrap([-30, 30], i) });
                    const shard = glass.querySelector(".UIShard");
                    const { top, left, right } = shard.getBoundingClientRect();
                    gsap.set(glass, {
                        x: [-right, Viewport.windowWidth - left, 0][i],
                        y: [120, 120, Viewport.windowHeight - top][i]
                    });
                    tl
                        .to(glass, {
                        x: 0,
                        y: 0,
                        rotation: 0,
                        onComplete: i === pieces.length - 1 ? onComplete : undefined
                    }, 0)
                        .float(glass, {
                        duration: [frames(i % 2 === 0 ? 210 : 180), frames(i % 2 === 0 ? 180 : 210)]
                    }, ">");
                });
                return tl;
            })(), 0);
        }
        function onBeforeLeave(el) {
            const $ = gsap.utils.selector(el);
            gsap.killTweensOf($(".Glass"));
            stopShardsParallax();
        }
        function onLeave(el, onComplete) {
            const $ = gsap.utils.selector(el);
            const ease = "ease.out";
            const tl = gsap.timeline({
                onComplete,
                defaults: { ease }
            });
            tl
                .to($(".Title, .Logos"), {
                opacity: 0,
                duration: frames(60)
            }, 0);
            // shards
            tl.add((() => {
                const tl = gsap.timeline({
                    defaults: {
                        duration: frames(100),
                        ease
                    }
                });
                const pieces = $(".Glass");
                pieces.forEach((glass, i) => {
                    gsap.killTweensOf(glass);
                    const shard = glass.querySelector(".UIShard");
                    const { top, left, right } = shard.getBoundingClientRect();
                    tl
                        .to(glass, {
                        // x: [-right, Viewport.windowWidth - left, 0][i],
                        // y: [345, 408, Viewport.windowHeight - top][i],
                        x: [-right, Viewport.windowWidth - left, 0][i],
                        y: [120, 120, Viewport.windowHeight - top][i],
                        rotation: gsap.utils.wrap([-30, 30], i),
                        opacity: 0
                    }, 0);
                });
                return tl;
            })(), 0);
        }
        return (_ctx, _cache) => {
            const _component_UIMaskReveal = _resolveComponent("UIMaskReveal");
            const _component_UIShard = _resolveComponent("UIShard");
            return (_openBlock(), _createBlock(_Transition, {
                css: false,
                onBeforeEnter: onBeforeEnter,
                onEnter: onEnter,
                onBeforeLeave: onBeforeLeave,
                onLeave: onLeave
            }, {
                default: _withCtx(() => [
                    _withDirectives(_createElementVNode("div", _hoisted_1, [
                        _createVNode(_component_UIMaskReveal, {
                            as: "h2",
                            class: "Title text-mobile-subtitle lg:text-desktop-subtitle-1",
                            delay: _ctx.delay
                        }, {
                            default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t("landing.title")), 1)
                            ]),
                            _: 1
                        }, 8, ["delay"]),
                        _createElementVNode("div", _hoisted_2, [
                            _hoisted_3,
                            _createElementVNode("div", _hoisted_4, [
                                _hoisted_5,
                                _createElementVNode("span", {
                                    class: "Logo",
                                    "data-row": _unref(Viewport).isMobile ? 2 : 1
                                }, _hoisted_8, 8, _hoisted_6),
                                _createElementVNode("span", {
                                    class: "Logo",
                                    "data-row": _unref(Viewport).isMobile ? 3 : 1
                                }, _hoisted_11, 8, _hoisted_9),
                                _createElementVNode("span", {
                                    class: "Logo",
                                    "data-row": _unref(Viewport).isMobile ? 4 : 1
                                }, _hoisted_14, 8, _hoisted_12)
                            ]),
                            _createElementVNode("span", {
                                class: "Logo",
                                "data-row": _unref(Viewport).isMobile ? 5 : 2
                            }, _hoisted_17, 8, _hoisted_15)
                        ]),
                        _createElementVNode("div", _hoisted_18, [
                            _createElementVNode("div", _hoisted_19, [
                                _createVNode(_component_UIShard, { variant: "2" })
                            ]),
                            _createElementVNode("div", _hoisted_20, [
                                _createVNode(_component_UIShard, { variant: "1" })
                            ]),
                            _createElementVNode("div", _hoisted_21, [
                                _createVNode(_component_UIShard, { variant: "3" })
                            ])
                        ])
                    ], 512), [
                        [_vShow, _unref(show)]
                    ])
                ]),
                _: 1
            }));
        };
    }
});
